import { Button } from '@casavo/base-ui'
import { Body } from '@casavo/habitat'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'

import { useDevice } from '@/context/Device'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

import { MORTGAGE_BANNER_VALUATION_LINK } from './constants'
import { mortgageBannerValuation } from './styles.css'

export const MortgageBannerValuationModal: React.FC<{
  className?: string
  onBannerCtaClick: VoidFunction
}> = ({ className, onBannerCtaClick }) => {
  const { t } = useTranslation()
  const device = useDevice()
  return (
    <div className={cn(mortgageBannerValuation, className)}>
      <div className={sprinkles({ marginBottom: 's-m' })}>
        <Body strong size="m">
          {t('suggested:ForYou_Page_Mortgage_CardTitle')}{' '}
          <span aria-hidden="true" role="img">
            🎯
          </span>
        </Body>
      </div>
      <Body size="s">{t('suggested:ForYou_Page_Mortgage_Card_Description')}</Body>
      <Button
        center
        className={sprinkles({ marginTop: 'xl' })}
        fullWidth={device === 'mobile'}
        label={t('suggested:ForYou_Page_Mortgage_Card_CTA')}
        onClick={() => {
          onBannerCtaClick()
          window.open(MORTGAGE_BANNER_VALUATION_LINK, '_blank')
        }}
      />
    </div>
  )
}
